export default {
  apiKey: "AIzaSyBjzCb97X_EBQUgui7MBkhrOrWx1dFVOSY",
  authDomain: "emc-mdnacloud-poc-t.firebaseapp.com",
  projectId: "emc-mdnacloud-poc-t",
  storageBucket: "emc-mdnacloud-poc-t.firebasestorage.app",
  messagingSenderId: "297055956959",
  appId: "1:297055956959:web:a2a1f8458009418f34de6a",
  databaseURL: "https://emc-mdnacloud-poc-t.firebaseapp.com"
};
